import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import Home from "@/screens/Home";
import Login from "@/screens/Login";
import RecoveryPassword from "@/screens/RecoveryPassword";
import SignupCompany from "@/screens/SignUp/SignUpCompany";
import SignUpCustomer from "@/screens/SignUp/SignUpCustomer";
import Welcome from "@/screens/Welcome";

export type AuthStackParamList = {
  login: undefined;
  welcome: undefined;
  signupCompany: undefined;
  signupCustomer: undefined;
  guest: undefined;
  recoveryPassword: undefined;
};

export type AuthNavigation = StackNavigationProp<AuthStackParamList>;

export const AuthRoutePaths = {
  login: "login",
  welcome: "bem-vindo",
  signupCompany: "cadastro-empresa",
  signupCustomer: "cadastro-cliente",
  guest: "convidado",
  recoveryPassword: "recuperar-senha",
};

const Stack = createStackNavigator<AuthStackParamList>();

const AuthenticationStack = () => {
  const { isWebMode } = useViewport();
  return (
    <Stack.Navigator
      initialRouteName={isWebMode ? "guest" : "welcome"}
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <Stack.Screen name="welcome" component={Welcome} options={{ title: "Bem vindo" }} />
      <Stack.Screen name="guest" component={Home} options={{ title: "iFeira" }} />
      <Stack.Screen name="login" component={Login} options={{ title: "Entre ou Cadastre-se" }} />
      <Stack.Screen
        name="signupCompany"
        component={SignupCompany}
        options={{ title: "Cadastro" }}
      />
      <Stack.Screen
        name="signupCustomer"
        component={SignUpCustomer}
        options={{ title: "Cadastro" }}
      />
      <Stack.Screen
        name="recoveryPassword"
        component={RecoveryPassword}
        options={{ title: "Recuperar Senha" }}
      />
    </Stack.Navigator>
  );
};

export default AuthenticationStack;
